import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('expenseLineItem'),
  ...new Mutations('expenseLineItems'),
  ...new Mutations('pettyCashAdvanceDocumentLines'),
  ...new Mutations('pettyCashADocumentLines'),
};
